import React from "react";
import { Chip } from "@mui/material";
import { BADGE_COLORS, getBadgeStyles } from "../../../../components/ui/badgeColors";
import { ETIQUETAS_ENTRADA_ESTADO } from "../../constants";
import { generarEtiquetaEstado } from "../../helpers/entradas";

const TAMANOS = {
    normal: { height: 24, fontSize: 11 },
    small: { height: 20, fontSize: 10 },
    // Legible a varios metros (pantalla de turnos)
    large: { height: 36, fontSize: 18 },
};

/**
 * Badge del estado de una entrada de cola con los colores corporativos.
 * Un estado desconocido o vacío se muestra en gris con el texto recibido (o '-').
 */
const EstadoEntradaBadge = ({ estado, size = "normal" }) => {
    const color = ETIQUETAS_ENTRADA_ESTADO[estado]?.color ?? BADGE_COLORS.GRAY;
    return (
        <Chip
            label={generarEtiquetaEstado(estado)}
            size="small"
            sx={getBadgeStyles(color, TAMANOS[size] ?? TAMANOS.normal)}
        />
    );
};

export default EstadoEntradaBadge;
